
import { ElNotification as notify } from 'element-plus'
import { defineComponent } from 'vue';
import logo from './logo.vue'
// import breadcrumb from './breadcrumb.vue'
// import reference from './reference.vue'
import panel from './panel.vue'
import navBar from '../navbar/index.vue'


export default defineComponent({
    name: 'page-header',
    components: {
        logo,
        // breadcrumb,
        // reference,
        panel,
        navBar,
    },
    setup() {
        const onBack = () => {
            notify('Back')
        }
        return {
            onBack
        };
    },
})
